var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Zip_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Zip_svg__st1{display:none}.Zip_svg__st5{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#1334cb}.Zip_svg__st10{fill:#1a0826}")), /*#__PURE__*/React.createElement("path", {
    d: "M38 24H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h36c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.9 9.7 1 8.2h9.8l-1-8.2z",
    style: {
      fill: "#aa8fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 6.6c.6.6.7 1.5.2 2.1s-1.4.5-2.1-.1c-.6-.6-.7-1.5-.2-2.1.5-.5 1.5-.5 2.1.1",
    className: "Zip_svg__st10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36 12.6c-.2-1.8-1.7-2.9-3.6-2.9h-6.5l1 8.2h2.9l-.2-1.6h3.1c2.4-.1 3.6-1.6 3.3-3.7m-3.6 1.3h-3.1l-.2-2h3.1c.7 0 1.1.4 1.2 1 0 .4-.2 1-1 1",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1a0826"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.7 15.6.3 2.3h9.8l-.3-2.6H9.9V15l4.1-3-.3-2.3H4l.3 2.6h4.6v.3z",
    className: "Zip_svg__st10"
  })));
};
export default SvgZip;